import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const ABANDON_DAYS = 15;
const DAY = 86400000;

export const orderCategory = (o) => {
  if (o.payment_status === "cancelled") return "cancelled";
  if (o.payment_status === "paid") {
    if (o.fulfillment_status === "livree") return "delivered";
    if (o.fulfillment_status === "expediee") return "shipped";
    return "active";
  }
  const since = new Date(o.reinstated_at || o.created_at).getTime();
  return Date.now() - since > ABANDON_DAYS * DAY ? "abandoned" : "pending";
};

export const ORDER_TABS = [
  ["active", "Commandes", ["active", "pending"]],
  ["shipped", "Expédiées", ["shipped"]],
  ["delivered", "Livrées", ["delivered"]],
  ["abandoned", "Historique des abandons", ["abandoned"]],
  ["cancelled", "Historique des annulations", ["cancelled"]],
];

const EMPTY = { active: "Aucune commande payée à traiter.", shipped: "Aucune commande expédiée.", delivered: "Aucune commande livrée.",
  abandoned: "Aucune commande abandonnée.", cancelled: "Aucune commande annulée." };

function PendingSection({ orders, renderOrder }) {
  const [open, setOpen] = useState(false);
  if (!orders.length) return null;
  return (
    <section data-testid="orders-pending-section" className="rounded-2xl border border-dashed border-amber-800/25 bg-sand/30">
      <button type="button" data-testid="orders-pending-toggle" onClick={() => setOpen((v) => !v)} className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left">
        <span className="font-serif text-lg font-semibold text-bark">En attente de paiement ({orders.length})</span>
        <span className="flex items-center gap-2 text-xs text-bark-soft">Basculent dans les abandons après {ABANDON_DAYS} jours <ChevronDown size={16} className={`transition-transform ${open ? "rotate-180" : ""}`} /></span>
      </button>
      {open && <div className="space-y-4 px-3 pb-3 sm:px-4 sm:pb-4">{orders.map(renderOrder)}</div>}
    </section>
  );
}

export default function OrdersView({ tab, orders, renderOrder }) {
  const main = orders.filter((o) => orderCategory(o) === (tab === "active" ? "active" : tab));
  const pending = tab === "active" ? orders.filter((o) => orderCategory(o) === "pending") : [];
  return (
    <div className="space-y-4">
      {main.length ? main.map(renderOrder) : <p data-testid="orders-empty" className="py-10 text-center font-serif text-xl text-bark-soft">{EMPTY[tab]}</p>}
      <PendingSection key={tab} orders={pending} renderOrder={renderOrder} />
    </div>
  );
}
